var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("add-address-modal", {
        ref: "addAddressModal",
        attrs: { customer: _vm.customer },
        on: {
          reFetchCustomer: function($event) {
            _vm.$emit("reFetchCustomer")
          }
        }
      }),
      _vm.addresses.length
        ? [
            _c(
              "q-field",
              {
                attrs: {
                  error: _vm.errors.has("invoice_address"),
                  "error-label": _vm.errors.first("invoice_address")
                }
              },
              [
                _c("q-select", {
                  ref: "invoiceAddress",
                  attrs: {
                    value: _vm.value.invoiceAddress,
                    "display-value": _vm.value.invoiceAddress
                      ? _vm.value.invoiceAddress.address_line_1
                      : null,
                    "float-label": _vm.$t("invoice_address"),
                    options: _vm.addresses,
                    "data-vv-as": _vm.$t("invoice_address"),
                    name: "invoiceAddress",
                    separator: "",
                    "hide-underline": ""
                  },
                  on: { input: _vm.updateInvoice }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      !_vm.addresses.length && _vm.errors.has("invoice_address")
        ? [
            _c("p", { staticClass: "text-negative" }, [
              _vm._v(_vm._s(_vm.$t("address_required")))
            ])
          ]
        : _vm._e(),
      !_vm.addresses.length
        ? _c(
            "q-btn",
            {
              staticClass: "q-mt-md add-address-btn",
              on: { click: _vm.handleAddAddress }
            },
            [_vm._v(_vm._s(_vm.$t("add_address")))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }